import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/vars';
  .TagItem {
    padding: 3px 13.5px;
    background: #343846;
    height: 25px;
    color: #fff;
    border-radius: 10px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    color: #fff;

    font-family: $ubuntu-font !important;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    .TagItem__delete {
      display: none;
    }
    &:hover,
    &:focus {
      padding: 3px 6px;
      .TagItem__delete {
        display: block;
      }
    }
  }
`;

export { staticStyles };
